import { render } from "./CreateAssessment.vue?vue&type=template&id=22f82414&scoped=true"
import script from "./CreateAssessment.vue?vue&type=script&lang=js"
export * from "./CreateAssessment.vue?vue&type=script&lang=js"

import "./CreateAssessment.vue?vue&type=style&index=0&id=22f82414&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f82414"]])

export default __exports__